// The current, canonical list of pages that privileges can be granted for.
// Keep this in sync with the "items" list used in AddRoles.js.
export const ROLE_PAGE_ITEMS = [
  "Dashboard",
  "Roles",
  "Users",
  "Staff",
  "Department",
  "Attendance",
  "Shift",
  "Leave Management",
  "Salary Details",
  "Holiday",
  "Doctors",
  "Treatment Charges",
  "Doctor Fee Master",
  "Patients",
  "Yoga Patients",
  "Homeopathy Patients",
  "Appointments",
  "Follow-up 1",
  "Follow-up 2",
  "Courtesy Call",
  // "IN Billing", // temporarily disabled
  "OUT Billing",
  "Medicine List",
  "Prescription",
  "Purchase Order",
  "Purchase List",
  "Sale Pharmacy",
  "Stock Management",
  "Supplier",
  "Reports Pharmacy",
  "Lab Management",
  "Expenses",
  "Hospital Maintenance",
  "Hospital Purchases",
  "Chat",
  "Reports",
];

// Roles created/saved before the 4Health Homeopathy rebrand still have the
// old page names stored in MongoDB (e.g. "Cardiology Patients", "Fertility
// Patients"). This maps those old names to the current ones so existing
// roles keep working without needing a manual one-off DB fix.
export const RETIRED_ROLE_PAGES = new Set(["IN Billing"]);

export const PAGE_NAME_MIGRATIONS = {
  "Cardiology Patients": "Homeopathy Patients",
  "Fertility Patients": "Yoga Patients",
};

const defaultPriviallages = () => ({
  all: false,
  create: false,
  read: false,
  update: false,
  delete: false,
  download: false,
});

/**
 * Renames any stale page names found in `pages` (from the backend) to their
 * current equivalents, and adds an entry (with no access) for any page in
 * `canonicalItems` that is missing entirely - e.g. because the role was
 * created before that page existed. Returns a new array; does not mutate.
 */
export function reconcileRolePages(pages = [], canonicalItems = []) {
  const renamed = pages
    .filter((p) => !RETIRED_ROLE_PAGES.has(p.page))
    .map((p) => {
    const mappedName = PAGE_NAME_MIGRATIONS[p.page] || p.page;
    return mappedName === p.page ? p : { ...p, page: mappedName };
  });

  const existingNames = new Set(renamed.map((p) => p.page));
  const missing = canonicalItems
    .filter((name) => !existingNames.has(name))
    .map((name, i) => ({
      page: name,
      id: String(renamed.length + i + 1).padStart(3, "0"),
      access: false,
      priviallages: defaultPriviallages(),
    }));

  return [...renamed, ...missing];
}
